<script setup lang="ts">
interface NoHeroLayoutProps {
  hideFooter?: boolean
  canonical?: string
  hideSpacer?: boolean
  hideNotice?: boolean
}

const props = defineProps<NoHeroLayoutProps>()

const route = useRoute()

useHead(() => {
  return {
    link: [
      {
        rel: 'canonical',
        href: props.canonical ?? `https://thuisgekookt.nl${route.path}`
      }
    ]
  }
})
</script>

<template>
  <div id="navbar-app">
    <header role="banner">
      <Navbar :show-transparent-effect="false" />
      <div v-if="!hideSpacer" class="spacer" />
    </header>

    <main>
      <slot />
    </main>

    <Footer v-if="!hideFooter" />
  </div>
</template>

<style scoped></style>
